import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-12 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="font-heading text-lg font-bold mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                一起草在线观看
              </Link>
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              免费高清视频播放平台，提供海量优质视频资源。无需注册，即点即看，随时随地畅享精彩内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">视频分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                  帮助中心
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-base"></i>
                <span>support@wgecino.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-customer-service-line text-base"></i>
                <span>在线客服：7×24小时</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 一起草在线观看 版权所有 | 致力于为用户提供优质的免费视频播放服务
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-300 cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-300 cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-300 cursor-pointer" aria-label="QQ">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}